import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { Workflow, WorkflowAutomation } from "./interface";
import Breadcrumbs from "./Breadcrumbs";
import { useTranslation } from "react-i18next";

interface Props {
  token: string;
  workflow: Workflow;
  automation: WorkflowAutomation;
  onCompleteAutomation: (automation: WorkflowAutomation) => void;
}

function AppWorkflowAutomation(props: Props) {
  const { t } = useTranslation();

  const { token, workflow, automation: initialAutomation, onCompleteAutomation } = props;

  const [currentAutomation, setCurrentAutomation] = useState<WorkflowAutomation>(initialAutomation);
  const [progress, setProgress] = useState(0);

  const fetchAutomation = useCallback(() => {
    fetch(`${process.env.REACT_APP_API_ENDPOINT}/hubspot/app/automations/${initialAutomation.id}/`, {
      headers: { "X-Token": token },
    })
      .then(response => response.json())
      .then(data => {
        setCurrentAutomation(data);
      })
      .catch(error => {
        console.error('Error fetching automation:', error);
      });
  }, [initialAutomation, token])

  useEffect(() => {
    if (currentAutomation && !["PENDING", "RUNNING"].includes(currentAutomation.status))
      return onCompleteAutomation(currentAutomation);

    fetchAutomation();
    const interval = setInterval(fetchAutomation, 2000);

    return () => clearInterval(interval);
  }, [fetchAutomation, currentAutomation, onCompleteAutomation]);

  // Trigger progress bar
  useLayoutEffect(() => {
    setTimeout(() => setProgress(1), 0);
  }, []);

  return (
    <div className="flex flex-col h-full">
      <Breadcrumbs workflow={workflow} currentPage="AUTOMATION" />

      <div className="flex h-full">
        <div className="flex flex-col items-center justify-center gap-2 m-auto">
          <img src="https://static.portant.co/portant-loading-blue.svg" alt="Loading Logo" className='w-32 h-32' />
          <div className="text-gray-400 font-semibold text-center text-sm mt-2">{t("Generating documents")}...</div>

          <div className="w-[400px] h-2 bg-gray-200 rounded-full overflow-hidden relative">
            <div className="bg-blue h-full transition-width absolute left-0 top-0" style={{ width: `calc(95% * ${progress})`, transitionDuration: "40s", transitionTimingFunction: "ease-out" }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppWorkflowAutomation;
